import { HOVER_CLIPS, type Clip } from "@softmax/avatar/character";

export const reducedMotion = (): boolean =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export function pickHoverClip(previous: Clip | null): Clip {
  const candidates = HOVER_CLIPS.filter((clip) => clip !== previous);
  const selected = candidates[Math.floor(Math.random() * candidates.length)];

  if (selected === undefined)
    throw new Error("The avatar has no available hover clip.");

  return selected;
}

export function glideKeyframes({
  dx,
  dy,
  distance,
}: Readonly<{ dx: number; dy: number; distance: number }>): Keyframe[] {
  const overshoot = Math.min(3, distance);
  return [
    { translate: `${dx}px ${dy}px` },
    {
      translate: `${(-dx / distance) * overshoot}px ${(-dy / distance) * overshoot}px`,
      offset: 0.78,
    },
    { translate: "0px 0px" },
  ];
}
